import { PERMISSION } from '@/constants/permission.constant';

const list = () => import('@/views/news/List.vue');
const edit = () => import('@/views/news/Edit.vue');
const create = () => import('@/views/news/Create.vue');

export const newsRoute = [
  {
    path: '/news/new',
    name: 'new-list',
    component: list,
    meta: { requiresAuth: false, permissions: [PERMISSION.NEW_READ] },
  },
  {
    path: '/news/new/create',
    name: 'new-create',
    component: create,
    meta: { requiresAuth: false, permissions: [PERMISSION.NEW_CREATE] },
  },

  {
    path: '/news/new/:id/edit',
    name: 'new-update',
    component: edit,
    meta: { requiresAuth: false, permissions: [PERMISSION.NEW_UPDATE] },
  },
];
